import { AxiosInstance } from 'axios';
import Axios from './axios.service';

export default class ConversationService {
  private request: AxiosInstance;

  constructor() {
    this.request = Axios.getInstance();
  }

  listConversations = async (dateInit: string, dateFin: string, pageSize: number, page: number) => {
    return this.request.post(`/conversation/list-conversation`, {
      dateInit,
      dateFin,
      pageSize,
      page
    });
  };

  listMessages = async (conversationId: string, pageSize: number, page: number) => {
    return this.request.get(`/conversation/list-messages/${conversationId}`, {
      params: { pageSize, page }
    });
  };

  exportConversations = async (dateInit: string, dateFin: string) => {
    return this.request.post(
      `/conversation/export`,
      { dateInit, dateFin },
      { responseType: 'blob' }
    );
  };

  exportMessages = async (conversationId: string) => {
    return this.request.post(
      `/conversation/export/${conversationId}`,
      {},
      { responseType: 'blob' }
    );
  };

  getConversation = async (conversationId: string) => {
    return this.request.get(`/conversation/${conversationId}`);
  };
}
